<template>
    <page :busy="busy" :tabs="tabs">
        <router-view></router-view>
    </page>
</template>

<script>
import Page from '../generic/page/page.vue';
import { templatesMixin } from './mixins/templates-mixin';

export default {
    name: 'SeasonalityTemplate',
    components: {
        Page,
    },
    mixins: [templatesMixin],
    mounted() {
        if (this.$route.path === '/app/seasonality-template/') {
            this.$router.push('/app/seasonality-template/templates/');
        }
    },
    computed: {
        tabs() {
            const tabs = [];
            tabs.push({
                title: `Templates`,
                route: `/app/seasonality-template/templates/`,
                active: this.$route.path === `/app/seasonality-template/templates/`,
            });
            tabs.push({
                title: `Properties`,
                route: `/app/seasonality-template/properties/`,
                active: this.$route.path === `/app/seasonality-template/properties/`,
            });
            tabs.push({
                title: `Settings`,
                route: `/app/seasonality-template/settings/`,
                active: this.$route.path === `/app/seasonality-template/settings/`,
            });
            return tabs;
        },
    },
};
</script>